/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SessionmanagementService } from '../../core/services/sessionmanagement.service';
import { Constants } from '../../core/constants';

@Component({
  selector: 'sita-timeout',
  standalone: false,
  templateUrl: './timeout.component.html',
  styleUrl: './timeout.component.scss'
})
export class TimeoutComponent implements OnInit{

  title: string = Constants.TIMEOUT_TITLE;
  bodyText: string = Constants.TIMEOUT_BODY;
  headerClass = "user-color";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public readonly dialogRef: MatDialogRef<TimeoutComponent>, private readonly sessionSrvc: SessionmanagementService) { }

  ngOnInit(): void {
    if(this.data){
      this.title = this.data.title ? this.data.title : this.title;
      this.bodyText = this.data.bodyText ? this.data.bodyText : this.bodyText;
    }

    if(this.sessionSrvc.isLoggedIn() &&  this.sessionSrvc.isAdmin){
      this.headerClass = "admin-color"
    }
  }

  actionFunction() {
    this.closeModal();
  }

  // If the user clicks the cancel button a.k.a. the go back button, then\
  // just close the modal
  closeModal() {
    this.dialogRef.close();
    this.sessionSrvc.logout();
  }
}
